// import { csrfFetch } from "./csrf"; // No longer needed for frontend-only mode
//create, read, update, delete

//------------------------------create requests---------------------------------
const ADD_REQUEST = "requests/ADD"
export const addRequest = (request) => ({
  type: ADD_REQUEST,
  request
});

export const postRequest = (request) => async(dispatch) => {
  // For frontend-only demo, simulate creating a new request
  const new_request = {
    id: Date.now(),
    ...request,
    created_at: new Date().toISOString()
  };

  dispatch(addRequest(new_request));
};

//------------------------------load requests---------------------------------
const LOADALL_REQUESTS = "requests/LOADALL"
export const loadRequests = requests => ({
    type: LOADALL_REQUESTS,
    requests
});

export const getAllRequests = () => async (dispatch) => {
  // For frontend-only demo, return mock request data
  const mockRequests = {
    requests: [
      {
        id: 1,
        amount: 20.00,
        note: "Lunch money request 🍕",
        user_id: 2,
        recipient_id: 1,
        username: "alice_smith",
        recipient: "demo_user",
        created_at: new Date().toISOString()
      },
      {
        id: 2,
        amount: 12.50,
        note: "Gas money ⛽",
        user_id: 1,
        recipient_id: 3,
        username: "demo_user",
        recipient: "john_doe",
        created_at: new Date().toISOString()
      }
    ]
  };
  dispatch(loadRequests(mockRequests));
}

//------------------------------update requests---------------------------------
const UPDATE_REQUEST = "requests/UPDATE"
export const updateRequest = updatedRequest => ({
  type: UPDATE_REQUEST,
  updatedRequest
})

export const updatingRequest = request => async(dispatch) => {
  // For frontend-only demo, simulate updating a request
  const updatedRequest = {
    ...request,
    updated_at: new Date().toISOString()
  };
  
  dispatch(updateRequest(updatedRequest));
  return updatedRequest;
}

//------------------------------delete requests---------------------------------
const DELETE_REQUEST = "requests/DELETE"
export const removeRequest = (removedRequest) => ({
  type: DELETE_REQUEST,
  removedRequest
})

export const deleteRequest = (request_id) => async(dispatch) => {
  // For frontend-only demo, simulate deleting a request
  const requestNum = { request_id };
  dispatch(removeRequest(requestNum));
}

//------------------------------requests reducer---------------------------------
const requestReducer = (state = {}, action) => {
  let newState = { ...state };

  switch(action.type) {
    case LOADALL_REQUESTS:
      if (action.requests) {
        action.requests.requests.forEach(
          (request) => (newState[request.id] = request))
      } else {
        newState = {}
      }
      return newState
    case ADD_REQUEST:{
      newState[action.request.id] = action.request;

      return newState;
    }
    case UPDATE_REQUEST: {
      newState[action.updatedRequest.id] = action.updatedRequest;

      return newState;
    }
    case DELETE_REQUEST:
      delete newState[action.removedRequest.request_id];

      return newState;
    default:
      return state;
  }
}

export default requestReducer;
